import { createTheme } from '@mui/material/styles';

// Pastel Color Palette - Green, Gold, White
const pastelColors = {
  greenPastel: {
    light: '#E8F5E9',
    main: '#A5D6A7',
    dark: '#81C784',
    contrastText: '#2E7D32',
  },
  goldPastel: {
    light: '#FFF9E6',
    main: '#FFD54F',
    dark: '#FFC107',
    contrastText: '#F57F17',
  },
  whitePastel: {
    light: '#FFFFFF',
    main: '#FAFAFA',
    dark: '#F5F5F5',
    contrastText: '#424242',
  },
};

const landingTheme = createTheme({
  typography: {
    fontFamily: 'Sarabun, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: 'Sarabun, sans-serif',
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: 'Sarabun, sans-serif',
      fontWeight: 600,
      fontSize: '2.5rem',
      lineHeight: 1.3,
    },
    h3: {
      fontFamily: 'Sarabun, sans-serif',
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.4,
    },
    h4: {
      fontFamily: 'Sarabun, sans-serif',
      fontWeight: 500,
      fontSize: '1.75rem',
      lineHeight: 1.4,
    },
    h5: {
      fontFamily: 'Sarabun, sans-serif',
      fontWeight: 500,
      fontSize: '1.5rem',
      lineHeight: 1.5,
    },
    h6: {
      fontFamily: 'Sarabun, sans-serif',
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.6,
    },
    body1: {
      fontFamily: 'Sarabun, sans-serif',
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: 'Sarabun, sans-serif',
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
    button: {
      fontFamily: 'Sarabun, sans-serif',
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  palette: {
    primary: pastelColors.greenPastel,
    secondary: pastelColors.goldPastel,
    background: {
      default: pastelColors.whitePastel.main,
      paper: pastelColors.whitePastel.light,
    },
    text: {
      primary: '#1B5E20',
      secondary: '#558B2F',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&display=swap');
        
        body {
          font-family: 'Sarabun', sans-serif;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          fontSize: '1rem',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

export default landingTheme;
